import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_console/projects")({
  component: ProjectsWorkspaceRoute,
});

function ProjectsWorkspaceRoute() {
  return <Outlet />;
}
